import { apiGET } from '../utils/adapterFunctions'

export const getCEPData = async ({ cep }) => {
  return apiGET(`/registration/cep/${cep}`)
}